export default __webpack_public_path__ + "static/media/AG13.a1bc1a7d.mp3";